import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { StudentResultStyle } from "@styles/student-portal/StudentResultStyle";
import { RubricTable as CommonRubricTable } from "@components/common/RubricTable";
import { IRubricInfo } from "@repositories/model/transfer/IRubricInfo";

type Props = {
	rubricInfo: IRubricInfo;
}

export const RubricTable = (props: Props) => {
	const classes = useEmotionStyles(StudentResultStyle);
	const { rubricInfo } = props;

	return (
		<CommonRubricTable
			rubricInfo={rubricInfo}
			variant="student-result"
			classes={classes}
		/>
	);
};
